import * as React from "react";
import type { SVGProps } from "react";

const FacilityHotel = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M14.1654 17.5V3.33333C14.1654 2.87333 13.792 2.5 13.332 2.5H6.66536C6.20536 2.5 5.83203 2.87333 5.83203 3.33333V17.5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83073 7.5H2.4974C2.0374 7.5 1.66406 7.87333 1.66406 8.33333V17.5"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3307 17.5V8.33333C18.3307 7.87333 17.9574 7.5 17.4974 7.5H14.1641"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.91406 14.1667H12.0807"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.2487 14.167V17.5003"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.7487 17.5003V14.167"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33203 8.74967H11.6654"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33203 11.2497H11.6654"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33203 6.24967H11.6654"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16406 11.2497H5.83073"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16406 14.1667H5.83073"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1641 11.2497H15.8307"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1641 14.1667H15.8307"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1654 17.4997H0.832031"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityHotel.displayName = "FacilityHotel";

export default FacilityHotel;
